module.exports = __webpack_public_path__ + "img/aisaku_camera_icon.3c76ce91.svg";